import { ViewModel,View } from "binder"
import { FormBuilderComponent } from "src/formBuilder/structure/components";
import { FormBuilderElement, IFormBuilderElementVisitor } from "src/formBuilder/structure/element";
import { CustomPropertyType, StringPropertyType } from "src/formBuilder/structure/propertyTypes/propetyTypes";
import  { SpanView } from "./span-view"
import { IStaticValueProvider } from "src/formBuilder/formBuilder/templateEditor/propertiesPanel/editors/IStaticValueProvider";
import { TranslatorEditorViewModel } from "./translatorEditor/translatorEditor-viewModel";



export class SpanComponent extends FormBuilderComponent{
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
        this.name = 'Span';
        this.addProperty("Translator","",new TranslatorPropertyType(this),null,false);
        this.addProperty("Text","",new StringPropertyType(this),"Text",true);
    }
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}

    CreateInternal(parent:ViewModel):FormBuilderElement{
        let result = new SpanElement(parent);
        return result;
    }
        
}

export class SpanElement extends FormBuilderElement{
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
    }
    GetDefaultView(): View <ViewModel> {
        return new SpanView();
    }
    public getTypeId(): string {
        return "VM-32CA94F1-C9A7-410D-8D7E-6330C0CA5EE8"
    }
    public set Text(v: string) { this._Text = v; } public get Text(): string { return this._Text;} private _Text: string;
    
    Accept(visitor: IFormBuilderElementVisitor, parameter: object): object {
        return visitor.VisitSpan(this,parameter);
    }
    
}
class TranslatorPropertyType extends CustomPropertyType{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:ViewModel) {
        super(parent);
        
    }

    getEditor(parent: ViewModel): IStaticValueProvider {
        return new TranslatorEditorViewModel(this);
    }
    
}